<template>
  <vue-dropzone
    ref="profileImageDropzone"
    id="vueProfileImageDropzone"
    :options="profileImageDzOptions"
    :destroyDropzone="false"
    @vdropzone-mounted="dropzoneMounted"
    @vdropzone-removed-file="dropzoneRemoveImage"
    @vdropzone-file-added="dropzoneUpdateHeader"
    @vdropzone-success="dropzoneUploadSuccess"
  >
    <div class="dz-default dz-message">
      <span>
        <i class="material-icons">cloud_upload</i><br>
        {{ $t('texts.imageUploadInfo') }}
      </span>
    </div>
  </vue-dropzone>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { apiDomain } from '@/config';

const { mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  props: {
    userImage: {
      type: String,
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      userData: {},
      profileImageDzOptions: {
        acceptedFiles: '.jpg,.jpeg,.png,.gif',
        paramName: 'image',
        resizeWidth: 500,
        resizeHeight: 500,
        resizeMethod: 'crop',
        maxFilesize: 5,
        maxNumberOfFiles: 2,
        maxFiles: 2,
        parallelUploads: 1,
        url: `${apiDomain}user/image`,
        addRemoveLinks: true,
        dictDefaultMessage: this.$i18n.t('texts.uploadProfilePicture'),
        dictRemoveFile: this.$i18n.t('texts.deleteProfilePicture'),
      },
      deleteFileFromServer: true,
    };
  },
  methods: {
    ...mapUserActions([
      'setProfileImage',
    ]),
    ...mapMessageActions([
      'showMessage',
    ]),
    dropzoneMounted() {
      if (this.userImage) {
        Vue.nextTick(() => {
          const file = {
            size: 1,
            name: '',
            type: 'image/jpg',
          };
          const options = {
            dontSubstractMaxFiles: true,
            addToFiles: false,
          };
          this.$refs.profileImageDropzone.manuallyAddFile(file, this.userImage, null, null, options);
        });
      }
    },
    dropzoneUploadSuccess(file, response) {
      this.setProfileImage(response)
        .then(() => {
          // Check how many logos are currently added
          const files = { ...this.$refs.profileImageDropzone.dropzone.files };
          const numberOfFiles = Object.keys(files).length;
          if (numberOfFiles > 1) {
            // Set deleteFileFromServer to false to prevent from deleting the new uploaded file from the server
            // as we need to use the removeFile method to remove the file from the dropzone field
            this.deleteFileFromServer = false;
            this.$refs.profileImageDropzone.removeFile(files[0]);
            this.deleteFileFromServer = true;
          }
          this.showMessage({
            key: 'alert.updateProfilePictureSuccessful',
            color: 'success',
          });
        });
    },
    dropzoneRemoveImage() {
      // TODO Move to store
      if (this.deleteFileFromServer) {
        axios
          .delete(`${apiDomain}user/image`)
          .then((response) => {
            if (response.status === 200) {
              this.setProfileImage(null)
                .then(() => {
                  this.showMessage({
                    key: 'alert.deleteProfilePictureSuccessful',
                    color: 'success',
                  });
                });
            }
          })
          .catch(() => {
            this.showMessage({
              key: 'alert.deleteProfilePictureError',
              color: 'error',
            });
          });
      }
    },
    dropzoneUpdateHeader() {
      this.$refs.profileImageDropzone.setOption('headers', { Authorization: `Bearer ${this.$auth.token()}` });
    },
  },
};
</script>
